import React from "react";
import serviceBg from "../../assets/img/bg/7.png";
import serviceBgVDO from "../../assets/img/bg/19.mp4";
import serviceIcons1 from "../../assets/img/service-icon/1.png";
import serviceIcons2 from "../../assets/img/service-icon/2.png";
import serviceIcons3 from "../../assets/img/service-icon/3.png";
import serviceIcons4 from "../../assets/img/icon/13.svg";
import serviceIcons5 from "../../assets/img/icon/17.svg";
import serviceIcons6 from "../../assets/img/icon/30.svg";
import serviceIcons7 from "../../assets/img/icon/21.svg";
import { IoIosArrowForward } from "react-icons/io";
import { IoArrowForwardSharp } from "react-icons/io5";
import { BiSupport } from "react-icons/bi";
import { CgWebsite } from "react-icons/cg";
import { BsDisplay } from "react-icons/bs";
import { AiFillShop } from "react-icons/ai";
import { Link } from "react-router-dom";

const services = [
  {
    id: 1,
    imgSrc: serviceIcons1,
    type: "image",
    title: "Mobile App Development",
    description:
      "We specialize in developing high-quality mobile apps for both iOS and Android platforms. Our apps are designed for seamless performance, intuitive user experience, and tailored to meet your specific business needs",
    link: "service-details.html",
  },
  {
    id: 3,
    imgSrc: serviceIcons3,
    type: "image",
    title: "E-commerce Solutions",
    description:
      "We offer end-to-end e-commerce solutions, creating scalable online stores with seamless user experience, secure payment integration, and ongoing support to help your business grow and thrive online",
    link: "service-details.html",
  },
  {
    id: 4,
    imgSrc: serviceIcons4,
    type: "image",
    title: "Product Support",
    description:
      "We provide comprehensive product support for your existing products, offering expert assistance, troubleshooting, and maintenance to ensure optimal performance and longevity, helping you maximize the value of your investment",
    link: "service-details.html",
  },
  {
    id: 5,
    imgSrc: serviceIcons5,
    type: "image",
    title: "Web Development",
    description:
      "We specialize in web development, creating responsive, high-performance websites tailored to your business needs. Our expert team delivers custom solutions that enhance user experience, boost engagement, and drive measurable growth",
    link: "service-details.html",
  },
  {
    id: 6,
    imgSrc: serviceIcons7,
    type: "image",
    title: "IT Training",
    description:
      "We offer specialized IT training programs designed to equip you with the latest skills in technology, including web development, cybersecurity, and cloud computing, ensuring you're prepared for real-world challenges and career advancement",
    link: "service-details.html",
  },
  {
    id: 7,
    imgSrc: serviceIcons6,
    type: "image",
    title: "Digital Marketing",
    description:
      "We provide strategic digital marketing services, including SEO, social media management, content creation, and PPC campaigns, designed to boost your online visibility, engage your audience, and drive sustainable business growth",
    link: "service-details.html",
  },
];

function Services() {
  return (
    <>
      <div
        className="breadcrumb-area bg-cover"
        // style={{ backgroundImage: `url(${serviceBg})` }}
      >
        <video autoPlay muted loop className="video-background">
          <source src={serviceBgVDO} type="video/mp4" />
        </video>
        <div className="container">
          <div className="breadcrumb-inner">
            <div className="row justify-content-center">
              <div className="col-lg-6">
                <h2 className="page-title">Service</h2>
              </div>
              <div className="col-lg-6 text-lg-end">
                <ul className="page-list">
                  <li>
                    <Link to={"/"}>Home</Link>
                  </li>
                  <IoIosArrowForward />
                  <li>Service</li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="service-area bg-relative pd-top-120">
        <div className="container">
          <div className="row">
            {services.map((service) => (
              <div key={service.id} className="col-lg-4 col-md-6">
                <div className="single-service-inner text-center">
                  <div className="thumb">
                    {service.type === "icon" ? (
                      <p style={{ fontSize: "3em", color: "#3C6BFD" }}>
                        {service.imgSrc}
                      </p>
                    ) : (
                      <img src={service.imgSrc} alt="img" />
                    )}
                  </div>
                  <div className="details">
                    <h5>{service.title}</h5>
                    <p>{service.description}</p>
                    {/* <a className="btn btn-border-base">
                      Touch More <i className="fa fa-plus"></i>
                    </a> */}
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </>
  );
}

export default Services;
